export class SDKErrorResponse {
    message: string;
    code: string;
    success: boolean;

    constructor(userCanceled: boolean, message: string = null) {
        this.success = false;
        this.setStatusCode(userCanceled, message);
        this.setStatusMessage(userCanceled, message);
    }

    public setStatusCode(userCanceled: boolean, message: string | any) {
        if (userCanceled) {
            this.message = 'Processo cancelado pelo usuário.';
        }
        if (message) {
            try {
                message = message.replace('Credrisk-', '');
                this.message = message;
            } catch (error) {
                this.message = 'Erro em alguma parametrização, consulte o suporte.';
            }
        }
    }

    private setStatusMessage(userCanceled: boolean, message: string) {
        if (userCanceled) {
            this.code = 'canceled_by_user';
        } else if (message) {
            try {
                message = message.replace('Credrisk-', '').toLowerCase();

                if (message.includes('valor a financiar dever ser')) {
                    this.code = 'erro_financiamento_valor';
                } else {
                    this.code = 'erro_parametrizacao';
                }
            } catch (error) {
                this.code = 'erro_parametrizacao';
            }
        }
    }
}